import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
    boton: {
        backgroundColor: '#0093E9',
        border: 0,
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        // borderRadius: 3,
        boxShadow: '0 3px 5px 2px #0093E931',
        color: 'white',
        height: 48,
        padding: '0 20px',
        // marginTop: '10px',
        '&:hover': {
            backgroundColor: '#0476b8',
        },
    },
})

const BotonAgregarTalento = () => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <Fab className={`${classes.boton} fade-in`} variant="extended" onClick={() => history.push('/talento/')}>
            <AddIcon style={{ paddingRight: 10 }} />Nuevo Talento
        </Fab>
    );
}

export default BotonAgregarTalento;